import React from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import PoweredBy from 'components/PoweredBy';

const TruncateText = (text) => {
  if (text.length > 60) {
    text = `${ text.substring(0, 59) }....`;
  }
  return text;
};

const ClientSelectForm = ({
  handleSubmit,
  errorMessage,
  onCloseErrorMessage,
  allClients
}) => (
  <form
    className="login-form"
    onSubmit={ values => handleSubmit(values) }
  >
    <div className="login-logo-container">
      <div className="login-logo" />
      <PoweredBy />
    </div>

    <h1 className="taina-brand">
      T<span className="taina-ai">AI</span>NA Fully Automated Tax Form Validator and Classifier
    </h1>

    <hr />

    <fieldset>
      <div className="form-group">
        <Field
          id="client-id"
          name="clientId"
          component="select"
          className="form-select"
          onChange={ () => onCloseErrorMessage() }
        >
          <option value="" disabled>Please, select a client</option>
          { allClients != null && allClients.map(client => client != null && <option key={ client.key } value={ client.key } title={ client.value }>{ TruncateText(client.value) }</option>) }
        </Field>
      </div>
    </fieldset>

    { errorMessage && <div className="error-wrapper">
      <div className="toast toast-error">
        <button
          type="button"
          className="btn btn-clear float-right"
          onClick={ () => onCloseErrorMessage() }
        />
        { (errorMessage.message)}
      </div>
    </div> }

    <div className="form-group submit-wrapper text-center">
      <button
        type="submit"
        className="btn btn-primary"
      >Go</button>
    </div>
  </form>
);

ClientSelectForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCloseErrorMessage: PropTypes.func.isRequired,
  allClients: PropTypes.arrayOf(PropTypes.shape()),
  errorMessage: PropTypes.shape({
    message: PropTypes.string
  })
};

ClientSelectForm.defaultProps = {
  allClients: [],
  errorMessage: null,
};

export default reduxForm({
  form: 'clientselect-form'
})(ClientSelectForm);
